import getEventTargetValue from '../utils/get-event-target-value';
import { changeQuoteLine } from './actions';
import { connectEditor } from './connect-editor';
import DetailsPopover from './QuoteLineTable/DetailsPopover';

export const connectDetailComponent = connectEditor(
  ({ quoteLinesById, productsById, quote }, { id }) => {
    const quoteLine = quoteLinesById[id];
    const product = productsById[quoteLine.productId];
    const isSalesforceQuote = !!quote.salesforceId;
    return {
      startDate: quoteLine.startDate,
      endDate: quoteLine.endDate,
      categories: quoteLine.categories,
      genders: quoteLine.genders,

      secondaryCountryCodes: quoteLine.secondaryCountryCodes,
      serviceDesc: quoteLine.serviceDesc,

      isPartOfCommercialPackage: quoteLine.isPartOfCommercialPackage,

      withCategories: product.overwriteCategories,
      withGender: product.overwriteGender,
      withTimeRange: product.overwriteTimeRange,

      withDescription: product.serviceDescription,

      timeGranularity: product.timeGranularity,
      hidden: !(
        product.overwriteCategories ||
        product.overwriteGender ||
        product.overwriteTimeRange
      ),
      isSalesforceQuote,
    };
  },
  {
    onChange: event =>
      changeQuoteLine(
        event.target.dataset.quoteLineId,
        event.target.name,
        getEventTargetValue(event.target),
        event.target.dataset.derived,
      ),
  },
);

export default connectDetailComponent(DetailsPopover);
